import { memo } from 'react'
import { ContactsTable, StackIcon } from 'shared/ui'

import { PopoverInfo } from '../PopoverInfo/PopoverInfo'
export function Executions_({ id }: { id: string }) {
	return (
		<button
			className={ContactsTable.css.cellAction}
			type='button'
			value={id}
			{...PopoverInfo.triggerListeners}
		>
			<StackIcon icon='info' width={18} />
		</button>
	)
}

export const Executions = memo(Executions_)
